/**
 * English mirror of ./strings.ar.js — GENERATED by scripts/i18n/build.mjs.
 *
 * Wording follows the legacy Locale/*.resx English resources wherever the
 * legacy screen had the same label. To change any of it, edit
 * scripts/i18n/strings.en.json and re-run the script.
 */

export const strings = {
  title: 'Reports',
  subtitle: 'Awareness programme indicators by period and department',

  headline: {
    title: 'Awareness programme indicators',
    note: 'For the whole organisation. Departments, and the names that need follow-up, are in Reports.',
    open: 'Detailed reports',
  },

  pdf: {
    action: 'Executive summary (PDF)',
    title: 'Security awareness executive summary',
    confidential: 'Internal document',
    footer: 'Rawam — Security Awareness Platform',
    departments: 'Departments',
    population: 'Employees counted',
    preparedBy: 'Prepared by',
    preparedOn: 'Prepared on',
    overview: 'At a glance',
    overviewNote: 'One figure for each part of the programme in the period.',
    incidents: 'Valid reports',
    followUp: 'Needs follow-up',
    followUpNote: 'Employees on each list. The full lists are on the follow-up page.',
    byDepartment: 'Departments',
    byDepartmentMore: 'Departments (continued)',
    department: 'Department',
    employees: 'Employees',
    organisation: 'Whole organisation',
    /* The department table's columns — ReportsEngine.Summary's matrix keys. */
    columns: {
      trainingCompletion: 'Completed training',
      assessmentPass: 'Passed assessments',
      clickRate: 'Clicked phishing',
      reportRate: 'Reported phishing',
      policyAcknowledgement: 'Acknowledged policies',
    },
    missing: '— No data, or a group of fewer than',
    missingUnit: 'employees, whose share is not shown.',
    quiet: 'Departments with no share shown:',
    separator: ', ',
    asOf: 'Data as of',
  },

  sections: {
    summary: 'Executive summary',
    phishing: 'Phishing behaviour',
    knowledge: 'Knowledge',
    training: 'Training coverage',
    policies: 'Policy compliance',
    incidents: 'Incident reporting',
    followUp: 'Follow-up',
  },

  tabs: {
    summary: 'Summary',
    phishing: 'Phishing',
    knowledge: 'Knowledge',
    training: 'Training',
    policies: 'Policies',
    incidents: 'Incidents',
    followUp: 'Follow-up',
  },

  questions: {
    summary: 'Is clicking going down and reporting going up? Is coverage complete? Which departments need follow-up?',
    phishing: 'Who clicks or submits data, who reports and how fast, and does it change from campaign to campaign?',
    knowledge: 'Who took the assessment, who passed, and which topics are weakest?',
    training: 'Completion measures exposure to content, not reduced risk.',
    policies: 'Has everyone a policy was issued to acknowledged its current version?',
    incidents: 'Are employees reporting suspicious events, and how many hold up?',
    followUp: 'The names behind each count, with every list exportable in full.',
  },

  filters: {
    label: 'Report scope',
    period: 'Period',
    periods: {
      quarter: 'Last full quarter',
      last30: 'Last 30 days',
      last12: 'Last 12 months',
      ytd: 'Year to date',
      custom: 'Custom period',
    },
    from: 'From',
    to: 'To',
    compare: 'Comparison',
    compares: {
      previous: 'With the previous period',
      year: 'With the same period last year',
      none: 'No comparison',
    },
    departments: 'Departments',
    allDepartments: 'All departments',
    departmentsCount: 'departments selected',
    pickDepartments: 'Choose departments',
    selectAll: 'Select all',
    searchDepartments: 'Search departments',
    noDepartments: 'No department matches',
    apply: 'Apply',
    clear: 'All departments',
    departmentsHint: 'Departments with employees in scope. Custom groups are not departments.',
  },

  meta: {
    comparedWith: 'Compared with',
    asOf: 'Status as of',
    updated: 'Updated',
    inScope: 'In scope',
    people: 'employees',
    populationTitle: 'Who the figures cover',
    populationHint:
      'Activated employees with the learner role who had not left by the end of the period. The system administrator account is not counted.',
    excluded: {
      awaitingActivation: 'Awaiting activation',
      suspended: 'Suspended',
      leftOrExpired: 'Left or expired',
      withoutDepartment: 'No department (in scope)',
    },
    suppression: 'Breakdown rates are hidden for groups smaller than',
    suppressionUnit: 'people',
  },

  actions: {
    refresh: 'Refresh figures',
    refreshed: 'Figures refreshed',
    export: 'Export',
    exportAll: 'The full report (Excel)',
    exportSection: 'only (Excel)', // after the tab's name: Training only (Excel)
    exportList: 'Export list',
    exported: 'The file is ready',
    exportFailed: 'Could not export the file',
    showTable: 'Show as table',
    showChart: 'Show as chart',
    retry: 'Try again',
    back: 'Reports',
    openList: 'Open the list',
    openProfile: 'Department profile',
  },

  states: {
    loadFailed: 'This section could not be loaded',
    loadFailedHint: 'The other sections are available. Try again in a moment.',
    invalidScope: 'The report scope is not valid',
    invalidScopeHint: 'Check the two dates. A period can be at most three years long.',
    empty: 'No data in this period',
    emptyHint: 'Try a longer period from the period list.',
    widen: 'Last 12 months',
    slow: 'Still calculating — this can take a few seconds.',
    notFound: 'Department not found',
    notFoundHint: 'It may have been deleted, or it has no employees in scope.',
  },

  standing: {
    departments: 'Departments',
    departmentsCount: 'departments',
    behind: 'Behind the organisation',
    behindCount: 'behind the organisation line',
    organisation: 'Organisation',
    interval: '95% interval',
    metric: 'Indicator',
    withheld: 'Departments not shown because they have fewer people than the minimum group size:',
    hint: 'Each dot is a department\'s rate, the bar behind it its 95% interval, and the dashed line the organisation\'s rate. A triangle is a department whose whole interval lies on the worse side of the organisation line. Click a dot to open the department.',
  },

  ledger: {
    previous: 'The mark on each bar, and each change in points: against the previous period',
    year: 'The mark on each bar, and each change in points: against the same period last year',
  },

  table: {
    search: 'Search by name',
    of: 'of',
    showing: 'Showing',
    showAll: 'Show all',
    showLess: 'Show fewer',
    noMatch: 'No matching rows',
  },

  indicators: {
    clickRate: 'Click rate',
    submitRate: 'Data submission rate',
    reportRate: 'Report rate',
    reportedWithoutClick: 'Reported without clicking',
    employeesClicked: 'Employees who clicked',
    assessmentPass: 'Assessment pass rate',
    assessmentParticipation: 'Assessment participation',
    examFirstAttemptPass: 'First-attempt pass rate',
    trainingCompletion: 'Training completion',
    trainingStarted: 'Training started',
    activeLearners: 'Active learners',
    policyAcknowledgement: 'Policy acknowledgement',
    reporterParticipation: 'Reporting participation',
    validShare: 'Reports confirmed valid',
  },

  definitions: {
    clickRate: 'Of the emails delivered in campaigns launched in the period: the share whose recipient clicked the link.',
    submitRate: 'Of the emails delivered: the share whose recipient entered data on the phishing page.',
    reportRate: 'Of the emails delivered: the share whose recipient reported it.',
    reportedWithoutClick: 'Of the emails delivered: the share whose recipient reported it without clicking.',
    employeesClicked: 'Of the employees who received at least one email: the share who clicked in any of them.',
    assessmentPass: 'Of the employees who completed an assessment in the period: the share who passed.',
    assessmentParticipation: 'Of the employees assigned an assessment in the period: the share who completed it.',
    examFirstAttemptPass: 'Of the course exams first taken in the period: the share passed at the first attempt.',
    trainingCompletion: 'Of the programme assignments as of the end of the period: the share completed.',
    trainingStarted: 'Of the programme assignments as of the end of the period: the share started.',
    activeLearners: 'Of the employees in scope: the share who recorded learning activity in the period.',
    policyAcknowledgement: 'Of the assignments of enabled policies: the share acknowledged on the current version by the end of the period.',
    reporterParticipation: 'Of the employees in scope: the share who sent at least one real report in the period.',
    validShare: 'Of the reports whose review is closed: the share confirmed as a real incident.',
  },

  units: {
    email: 'emails',
    person: 'employees',
    assignment: 'assignments',
    exam: 'exams',
    report: 'reports',
    campaign: 'campaigns',
    assessment: 'assessments',
    attempt: 'attempts',
    minute: 'minutes',
    hour: 'hours',
    day: 'days',
    programme: 'programmes',
    policy: 'policies',
  },

  stats: {
    campaigns: 'Campaigns',
    repeatClickers: 'Clicked in more than one campaign',
    medianMinutesToReport: 'Median time to report',
    medianMinutesToClick: 'Median time to click',
    assessments: 'Assessments',
    medianAttemptsToPass: 'Median attempts to pass',
    overdue: 'Overdue assignments',
    programmes: 'Programmes',
    personsCompletedAll: 'Completed all their programmes',
    pending: 'Pending acknowledgements',
    rejected: 'Rejected',
    medianDaysToAcknowledge: 'Median days to acknowledge',
    policiesWithoutAudience: 'Policies without an audience',
    reports: 'Reports',
    simulatedExcluded: 'Simulated reports excluded',
    anonymous: 'Anonymous reports',
    medianHoursToFirstResponse: 'Median time to first response',
  },

  reasons: {
    noCampaign: 'No campaign was launched in this period',
    noAudience: 'No one is assigned',
    noAssessment: 'No assessment in this period',
    notMeasurable: 'Not measurable in this period',
    noData: 'No data',
  },

  delta: {
    up: 'Up',
    down: 'Down',
    flat: 'Unchanged',
    points: 'pts',
    previous: 'on the previous period',
    year: 'on last year',
    before: 'before',
  },

  mix: {
    measuredOn: 'Measured on',
    campaigns: 'campaigns',
    easy: 'Easy',
    normal: 'Medium',
    hard: 'Hard',
    unrated: 'Unrated',
  },

  difficulty: { 0: 'Easy', 1: 'Medium', 2: 'Hard' },
  payload: { 0: 'Website', 1: 'Attachment', 2: 'Information Request' },

  cell: {
    behind: 'Behind',
    behindHint: 'This department\'s 95% interval lies entirely on the worse side of the organisation rate.',
    fewer: 'Fewer than',
    fewerHint: 'Fewer people than the minimum group size, so the rate is hidden to protect privacy.',
  },

  lists: {
    clicked: 'Clicked or submitted data',
    repeatClickers: 'Clicked in more than one campaign',
    overdueTraining: 'Overdue training',
    pendingPolicies: 'Policies awaiting acknowledgement',
    assessmentNotTaken: 'Did not take assessments',
    failedAssessment: 'Did not pass assessments',
  },

  listHints: {
    clicked: 'Everyone who clicked or submitted data in a campaign launched in the period, with the furthest stage reached.',
    repeatClickers: 'Everyone who clicked in two or more campaigns in the period.',
    overdueTraining: 'Assignments past their courses’ last date and not completed by the end of the period.',
    pendingPolicies: 'Assignments of enabled policies not acknowledged on the current version, with the reason.',
    assessmentNotTaken: 'Assigned an assessment overlapping the period and did not complete it.',
    failedAssessment: 'Completed the assessment and did not pass it.',
  },

  summary: {
    indicators: 'Headline indicators',
    needsAction: 'Needs action',
    needsActionHint: 'Counts that open the list of names behind them.',
    trend: 'Clicks and reports per campaign',
    trendScope: 'Campaigns launched in the 12 months to the end of the period',
    trendEmpty: 'No campaigns in the last 12 months',
    matrix: 'Departments against the organisation',
    matrixRule:
      'A cell is marked “Behind” when the department’s 95% interval lies entirely on the worse side of the organisation rate. With many departments, some marks occur by chance.',
    matrixEmpty: 'No department has employees in scope',
    behindIn: 'Behind on',
    flagged: 'behind on at least one indicator',
    behindOnly: 'Behind only',
    showCounts: 'Show counts',
    organisation: 'Organisation',
    pooled: 'assessments pooled',
    participation: 'Participation',
    coverage: 'Coverage by quarter',
    coverageScope: 'From the last daily snapshot in each quarter; a snapshot never changes once taken',
    coverageEmpty: 'No snapshots yet. The record starts the day this feature went live and grows every night.',
    coverageSince: 'Recorded since',
    quarter: 'Quarter',
  },

  columns: {
    department: 'Department',
    members: 'Employees',
    name: 'Name',
    campaign: 'Campaign',
    launched: 'Launched',
    category: 'Category',
    difficulty: 'Difficulty',
    payload: 'Payload',
    delivered: 'Delivered',
    opened: 'Opened or interacted',
    clicked: 'Clicked',
    submitted: 'Submitted data',
    reported: 'Reported',
    reportedWithoutClick: 'Reported without clicking',
    medianReport: 'Median time to report',
    template: 'Template',
    campaigns: 'Campaigns',
    assessment: 'Assessment',
    window: 'Assessment window',
    audience: 'Assigned',
    completers: 'Completed',
    participation: 'Participation',
    passed: 'Passed',
    meanScore: 'Mean score',
    topic: 'Topic',
    people: 'People',
    items: 'Answers',
    correct: 'Correct answers',
    course: 'Course',
    firstAttempt: 'First attempt',
    medianAttempts: 'Median attempts',
    programme: 'Programme',
    dueDate: 'Due date',
    assigned: 'Assigned',
    notStarted: 'Not started',
    inProgress: 'In progress',
    completedFailed: 'Completed, not passed',
    completedPassed: 'Completed and passed',
    completed: 'Completed',
    overdue: 'Overdue',
    completion: 'Completion',
    medianDays: 'Median days',
    activeLearners: 'Active learners',
    bulletin: 'Bulletin',
    published: 'Published',
    reach: 'Reach',
    survey: 'Survey',
    response: 'Response',
    policy: 'Policy',
    version: 'Version',
    acknowledged: 'Acknowledged',
    rejected: 'Rejected',
    notOpened: 'Not opened',
    downloadedOnly: 'Downloaded only',
    olderVersionOnly: 'Older version only',
    pending: 'Pending',
    rate: 'Acknowledgement rate',
    parent: 'Parent category',
    reports: 'Reports',
    population: 'Employees',
    reporters: 'Reporters',
    username: 'Username',
    employeeId: 'Employee ID',
    item: 'Item',
    status: 'Status',
    date: 'Date',
    days: 'Days',
    value: 'Count',
    score: 'Score',
    phishing: 'Phishing',
    training: 'Training',
    policies: 'Policies',
    assessmentResult: 'Assessment',
  },

  phishing: {
    campaigns: 'Campaigns',
    campaignsHint: 'Campaigns launched in the period; rates are of the emails delivered.',
    trend: 'Clicks and reports per campaign',
    departments: 'By department',
    departmentsHint: 'Pooled per-email rates, by the recipient’s department at launch.',
    templates: 'By template',
    templatesHint: 'Click rate per email, most clicked first. The dashed line is the organisation’s rate.',
    scannerCaveat: 'Automated clicks by mail-scanning systems are not yet excluded, so the click rate may be overstated.',
    difficultyCaveat: 'Comparisons between periods depend on campaign difficulty.',
    classifiedNote: 'Excluded from the click rate — recipients only an automated scanner touched:',
    openedNote: 'Shown only for campaigns with a tracking pixel.',
    minutes: 'minutes',
    noCampaigns: 'No campaign was launched in this period',
  },

  knowledge: {
    assessments: 'Assessments',
    assessmentsHint: 'Assessments whose window overlaps the period. Choose one to see its score distribution.',
    distribution: 'Score distribution',
    distributionHint: 'How many completers scored in each ten-point band.',
    pickAssessment: 'Choose an assessment from the table',
    topics: 'Topics',
    topicsHint: 'Share of correct answers per topic, from completed attempts. Weakest first.',
    topicsEmpty: 'No answers tagged with a topic in this period',
    organisationLine: 'Organisation average',
    organisationShort: 'Average',
    topicsAll: 'Topics across all assessments',
    compareWithheld: 'Topics not shown because fewer people than the minimum answered them in both:',
    compare: 'Before and after',
    compareHint:
      'Choose a baseline and a follow-up assessment. Only people who completed both are compared, and a change does not show that training caused it.',
    baseline: 'Baseline assessment',
    followUp: 'Follow-up assessment',
    choose: 'Choose an assessment',
    paired: 'Completed both',
    meanChange: 'Change in mean score',
    changeBy: 'Changed by',
    interval: '95% interval',
    compareSuppressed: 'Fewer people completed both than the minimum group size.',
    compareSame: 'Choose two different assessments.',
    courseExams: 'Course exams',
    courseExamsHint: 'First-attempt pass rate and the median number of attempts to pass.',
    departments: 'By department',
    open: 'Open',
    closed: 'Closed',
  },

  training: {
    status: 'Programme status',
    statusHint: 'Where each assignee stands at the end of the period. Four states that do not overlap.',
    programmes: 'Programmes',
    departments: 'By department',
    bulletins: 'Awareness bulletins',
    bulletinsHint: 'Bulletins published in the period, and the share of their audience who viewed them.',
    surveys: 'Surveys',
    surveysHint: 'The share of each survey’s audience who responded.',
    noProgrammes: 'No programme has anyone assigned',
  },

  policies: {
    policies: 'Policies',
    policiesHint: 'Enabled policies; acknowledgement is counted on each one’s current version.',
    departments: 'By department',
    noPolicies: 'No enabled policy has an audience',
    status: 'Where each policy’s audience stands',
    statusHint: 'One bar per policy, the whole of its audience, split by where each person stands on its current version. Least acknowledged first.',
  },

  incidents: {
    monthly: 'Reports per month',
    monthlyHint: 'Real reports only, by how they ended up.',
    outcomes: 'Review outcome',
    categories: 'By category',
    departments: 'By department',
    valid: 'Valid',
    false: 'Not valid',
    open: 'Under review',
    new: 'New',
    inProgress: 'In progress',
    simulationRule: 'Reports of simulated phishing emails are excluded: those the system flagged as simulations, or whose text starts with the automatic report phrase.',
    noReports: 'No reports in this period',
  },

  followUp: {
    list: 'List',
    search: 'Search by name, department or item',
    empty: 'No one is on this list',
    total: 'people',
  },

  status: {
    clicked: 'Clicked',
    submitted: 'Submitted data',
    notStarted: 'Not started',
    inProgress: 'In progress',
    notOpened: 'Not opened',
    downloadedOnly: 'Downloaded, not acknowledged',
    olderVersionOnly: 'Acknowledged an older version',
    rejected: 'Rejected',
    notTaken: 'Not taken',
    failed: 'Not passed',
  },

  notes: {
    reported: 'then reported',
    open: 'Assessment open',
    closed: 'Assessment closed',
  },

  profile: {
    title: 'Department profile',
    indicators: 'Department against the organisation',
    department: 'Department',
    organisation: 'Organisation',
    people: 'Employees',
    peopleHint: 'For each employee: the furthest stage in the period’s campaigns, training, pending policies and assessment result.',
    reported: 'Reported',
    tickLegend: 'The mark on each bar: the organisation’s rate',
    above: 'Above the organisation by',
    below: 'Below the organisation by',
    same: 'Level with the organisation',
  },

  charts: {
    outcomes: 'Phishing campaign outcomes',
    outcomesByMonth: 'Share of emails delivered, by month',
    outcomesByCampaign: 'Share of emails delivered, by campaign',
    riskMatrix: 'Department risk matrix',
    riskCaption: 'Phishing clicks against reporting',
    riskHint: 'Each bubble is a department, placed by its click and report rates and sized by its headcount. The dashed lines are the organisation\'s rates. Departments too small to show either rate are left out.',
    bubbleSize: 'Bubble size = headcount',
    resilient: 'Resilient',
    attention: 'Needs follow-up',
    coverageCaption: 'The rate at each quarter\'s end',
    needsActionCaption: 'People to follow up',
    matrixCaption: 'Each department against the organisation',
    departmentsCaption: 'Each department against the organisation\'s line',
    templates: 'Click rate by template',
    templatesCaption: 'The templates that caught most people, first',
    distributionCaption: 'Completers in each score band',
    score: 'Score / 100',
    weakTopics: 'Topics needing reinforcement',
    weakTopicsCaption: 'Share of answers that were incorrect, by topic',
    incorrect: 'Incorrect answers',
    improvementCaption: 'Average result for people who took both',
    activity: 'Learning activity',
    activityCaption: 'Programme completions, day by day',
    fewer: 'Fewer',
    more: 'More',
    busiestDay: 'Most active day',
    completions: 'completions',
    noActivity: 'Nobody completed a programme in this period',
    programmesCaption: 'Share of assigned employees in each programme',
    acceptance: 'Policy acknowledgement status',
    acceptanceCaption: 'Across every policy assignment',
    acknowledgedShort: 'Acknowledged',
    policiesCaption: 'Where the assigned employees stand, policy by policy',
    monthlyCaption: 'Reports by review outcome',
    outcomeCaption: 'All of the period\'s reports',
    reportsShort: 'reports',
    categoriesCaption: 'Reports in each category',
    day: 'Day',
    weekdays: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
    weekdaysShort: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
  },

  stages: {
    none: 'No campaign',
    delivered: 'Delivered',
    opened: 'Opened',
    clicked: 'Clicked',
    submitted: 'Submitted data',
  },

  assessmentStatus: {
    passed: 'Passed',
    failed: 'Not passed',
    notTaken: 'Not taken',
    none: 'Not assigned',
  },

  simple: {
    tabs: {
      summary: 'Overview',
      users: 'Users',
      training: 'Training',
      knowledge: 'Assessments',
      phishing: 'Phishing',
      policies: 'Policies',
      bulletins: 'Bulletins',
      surveys: 'Surveys',
      incidents: 'Incidents',
      followUp: 'Follow-up',
    },

    common: {
      department: 'Department',
      employees: 'Employees',
      noData: 'No data in this period',
      noRows: 'No data',
      fewer: 'Too few employees to show a share',
      of: 'of',
      open: 'Open',
      closed: 'Closed',
      people: 'employees',
      figures: 'Key figures',
      top: 'Top',
      lowest: 'Lowest',
      scopePeriod: 'Period',
      scopePeople: 'Employees counted',
    },

    overview: {
      modules: 'Reports',
      followUp: 'Needs follow-up',
      followUpHint: 'Employees on each list',
      openList: 'Open the list',
      users: 'Active in the period',
      training: 'Completed training',
      knowledge: 'Passed assessments',
      phishing: 'Clicked the phishing link',
      policies: 'Acknowledged policies',
      bulletins: 'Viewed bulletins',
      surveys: 'Answered surveys',
      incidents: 'reports in the period',
      incidentsValid: 'of them valid',
      unitPeople: 'employees',
      unitAssignments: 'assignments',
      unitParticipants: 'participants',
      unitEmails: 'emails',
      unitAudience: 'targeted',
    },

    users: {
      /* What each figure card counts — behind its (i). */
      info: {
        total: 'Employees with active accounts in the chosen period. The shares in this report are taken from them.',
        active: 'Employees who signed in to the platform at least once in the period. The share is of all employees.',
        inactive: 'Employees whose accounts are active but who did not sign in during the period.',
        notActive: 'Accounts left out of the reports: awaiting activation, suspended, or expired or left.',
      },
      total: 'Total employees',
      totalHint: 'Active accounts',
      active: 'Active',
      ofEmployees: 'of employees',
      inactive: 'Inactive',
      inactiveHint: 'Did not sign in',
      notActive: 'Inactive accounts',
      notActiveHint: 'Awaiting activation or suspended',
      activity: 'Employee activity in the period',
      accounts: 'Account status',
      inScope: 'Active',
      awaiting: 'Awaiting activation',
      suspended: 'Suspended',
      left: 'Expired or left',
      unit: 'employees',
      accountsUnit: 'accounts',
      byDepartment: 'Users by department',
      activeRate: 'Active share',
    },

    training: {
      /* What each figure card counts — behind its (i). */
      info: {
        programmes:
          'The training programmes covered by the chosen period, and how many are running today: their first course has opened and their last has not closed.',
        assignments: 'Each assignment is one employee in one programme, so an employee given three programmes counts three times.',
        completed: 'Assignments completed by the end of the period, passed or not. The share is of all assignments.',
        overdue: 'Assignments past their courses’ due date and not completed by the end of the period.',
      },
      programmes: 'Training programmes',
      runningNow: 'Running today:',
      /* Where each programme stands today, from its courses' dates — ProgramRowDto.Status. */
      state: 'Programme status',
      states: { running: 'Running', upcoming: 'Upcoming', ended: 'Ended' },
      assignments: 'Assignments',
      assignmentsHint: 'Each employee in each programme they were given',
      completed: 'Completed',
      ofAssignments: 'of assignments',
      overdue: 'Overdue',
      overdueHint: 'Past their due date',
      status: 'Training status',
      byProgramme: 'Completion by programme',
      passed: 'Completed and passed',
      failed: 'Completed, not passed',
      inProgress: 'In progress',
      notStarted: 'Not started',
      unit: 'assignments',
      programme: 'Programme',
      assigned: 'Assigned',
      completion: 'Completion',
      byDepartment: 'Training by department',
    },

    knowledge: {
      /* What each figure card counts — behind its (i). */
      info: {
        assessments: 'The assessments covered by the chosen period.',
        audience: 'Each employee in each assessment they were set, so an employee set two assessments counts twice.',
        participated: 'Those who completed the assessment out of those it was set for. The share is of the targeted.',
        passed: 'Those who reached the pass mark out of those who took part. The share is of the participants.',
      },
      assessments: 'Assessments',
      audience: 'Targeted',
      audienceHint: 'Each employee in each assessment they were given',
      participated: 'Took part',
      ofAudience: 'of those targeted',
      passed: 'Passed',
      ofParticipants: 'of participants',
      results: 'Assessment results',
      journey: 'From assigned to passed',
      byAssessment: 'Pass rate by assessment',
      failed: 'Did not pass',
      notTaken: 'Did not take part',
      unit: 'targeted',
      assessment: 'Assessment',
      state: 'Status',
      participation: 'Participation',
      passRate: 'Pass rate',
      meanScore: 'Mean score',
      byDepartment: 'Assessments by department',
    },

    phishing: {
      /* What each figure card counts — behind its (i). */
      info: {
        campaigns: 'The simulated phishing campaigns launched in the period.',
        sent: 'The simulated phishing emails delivered to employees in these campaigns.',
        clicked: 'Emails whose recipients clicked the link, including those who entered data. The share is of the emails sent; lower is better.',
        reported: 'Emails their recipients reported as phishing. The share is of the emails sent; higher is better.',
      },
      campaigns: 'Campaigns',
      sent: 'Emails sent',
      clicked: 'Clicked the link',
      reported: 'Reported the email',
      ofEmails: 'of emails',
      outcome: 'What employees did with the emails',
      journey: 'How far the emails got',
      submitted: 'Entered their details',
      clickedOnly: 'Clicked, no details entered',
      reportedOnly: 'Reported without clicking',
      ignored: 'Did nothing',
      unit: 'emails',
      campaign: 'Campaign',
      launched: 'Launched',
      sentShort: 'Sent',
      clickedShort: 'Clicked',
      submittedShort: 'Entered details',
      reportedShort: 'Reported',
      byDepartment: 'Phishing by department',
    },

    policies: {
      /* What each figure card counts — behind its (i). */
      info: {
        policies: 'The policies covered by the chosen period.',
        assignments: 'Each assignment is one employee in one policy, so an employee given two policies counts twice.',
        acknowledged: 'Assignments acknowledged by the end of the period. The share is of all assignments.',
        pending: 'Assignments neither acknowledged nor rejected by the end of the period.',
      },
      policies: 'Policies',
      assignments: 'Assignments',
      assignmentsHint: 'Each employee in each policy they were given',
      acknowledged: 'Acknowledged',
      ofAssignments: 'of assignments',
      pending: 'Awaiting acknowledgement',
      status: 'Policy acknowledgement status',
      byPolicy: 'Acknowledgement by policy',
      rejected: 'Rejected',
      unit: 'assignments',
      policy: 'Policy',
      version: 'Version',
      assigned: 'Assigned',
      rate: 'Acknowledgement rate',
      byDepartment: 'Policies by department',
    },

    bulletins: {
      /* What each figure card counts — behind its (i). */
      info: {
        bulletins: 'The awareness bulletins published in the period.',
        audience: 'Everyone these bulletins were sent to, so an employee sent two bulletins counts twice.',
        viewed: 'Those who opened the bulletin out of those it was sent to.',
        rate: 'Those who viewed the bulletins out of those they were sent to, leaving out any shown too few people to report.',
      },
      bulletins: 'Bulletins published',
      audience: 'Targeted',
      viewed: 'Viewed',
      rate: 'Viewed share',
      reach: 'Bulletin reach',
      byBulletin: 'Views by bulletin',
      notViewed: 'Did not view',
      unit: 'targeted',
      bulletin: 'Bulletin',
      published: 'Published',
      list: 'Bulletins',
    },

    surveys: {
      /* What each figure card counts — behind its (i). */
      info: {
        surveys: 'The surveys open during the period.',
        audience: 'Everyone given these surveys, so an employee given two surveys counts twice.',
        answered: 'Those who sent their answers out of those given the survey.',
        rate: 'Those who answered out of those given the surveys, leaving out any given too few people to report.',
      },
      surveys: 'Surveys',
      audience: 'Assigned',
      answered: 'Answered',
      rate: 'Response rate',
      response: 'Survey response',
      bySurvey: 'Response by survey',
      notAnswered: 'Did not answer',
      unit: 'assigned',
      survey: 'Survey',
      period: 'Period',
      list: 'Surveys',
    },

    incidents: {
      /* What each figure card counts — behind its (i). */
      info: {
        reports: 'The security incidents employees reported in the period.',
        valid: 'Reports reviewed and found valid. The share is of all reports.',
        false: 'Reports reviewed and found not valid.',
        open: 'Reports that are new and not yet reviewed, or still under review.',
      },
      reports: 'Reports',
      valid: 'Valid',
      false: 'Not valid',
      open: 'In progress',
      openHint: 'New or under review',
      ofReports: 'of reports',
      topCategories: 'Most reported categories',
      review: 'Report review outcome',
      isNew: 'New',
      inProgress: 'Under review',
      unit: 'reports',
      category: 'Category',
      parent: 'Parent category',
      count: 'Reports',
      byCategory: 'Reports by category',
      reporters: 'Employees who reported',
      participation: 'Participation',
      byDepartment: 'Reports by department',
    },
  },
}
